import { DefaultOptions, QueryClient, QueryKey } from 'react-query';

const queryConfig: DefaultOptions = {
  queries: {
    useErrorBoundary: false,
    refetchOnWindowFocus: false,
  },
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });

export const getQueryCacheByQueryKey = <T>(queryKey: QueryKey) =>
  queryClient.getQueryCache().find<T>(queryKey)?.state?.data;
